import { useLayoutEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import logo from "../assets/img/QBits9.webp";
import "./PageTransition.css";

export default function PageTransition() {
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);
  const [transition, setTransition] = useState(null);

  useLayoutEffect(() => {
    if (previousPath.current === pathname) return;
    previousPath.current = pathname;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setTransition(null);
      return;
    }

    setTransition({ pathname });
    // Always dismiss, even if animation events are interrupted.
    const timeout = window.setTimeout(() => setTransition(null), 650);
    return () => window.clearTimeout(timeout);
  }, [pathname]);

  if (!transition) return null;

  return (
    <div key={transition.pathname} className="page-transition" aria-hidden="true">
      <div className="page-transition__mark">
        <span className="page-transition__ring" />
        <span className="page-transition__logo">
          <img src={logo} alt="" width="472" height="118" />
        </span>
      </div>
    </div>
  );
}
